module.exports = __webpack_public_path__ + "Server-Disabled-Kubernetes.28293586a4f4cd39e1590b8edb686f30.hashedasset.svg";